import { render, staticRenderFns } from "./DesignerGridLayoutItem.vue?vue&type=template&id=e5b654e2"
import script from "./DesignerGridLayoutItem.vue?vue&type=script&lang=js"
export * from "./DesignerGridLayoutItem.vue?vue&type=script&lang=js"
import style0 from "./DesignerGridLayoutItem.vue?vue&type=style&index=0&id=e5b654e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports